// extracted by mini-css-extract-plugin
module.exports = {"li":"qa-module--li--mGrDj","question":"qa-module--question--2xCng","answer":"qa-module--answer--MCHu1"};